import { Switch, Route, Redirect } from "react-router-dom";
import Login from "./Login";
import { useAuth } from "../../context/AuthContext";

const AuthRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Switch>
      <Route exact path="/pages/login" component={Login} />
      <Redirect to="/pages/login" />
    </Switch>
  );
};

export default AuthRoutes;
